import { useState } from "react";
import { Upload } from "lucide-react";
import MasterCrud from "@/components/app/MasterCrud";
import ImportDialog from "@/components/app/ImportDialog";
import { canEditMaster, useAuth } from "@/lib/auth";

export default function Products() {
  const { user } = useAuth();
  const [importOpen, setImportOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const toolbar = canEditMaster(user) ? (
    <button onClick={() => setImportOpen(true)} className="gc-btn-ghost text-sm ml-auto" data-testid="btn-import-products"><Upload className="w-4 h-4" /> Import Produk</button>
  ) : null;
  return (
    <>
      <MasterCrud
        key={refreshKey}
        endpoint="/products"
        title="Produk"
        description="Daftar produk beton yang diproduksi, termasuk paving blok berpori rendah karbon dan produk konvensional."
        fields={[
          { key: "code", label: "Kode Produk", type: "text", required: true },
          { key: "name", label: "Nama Produk", type: "text", required: true },
          { key: "category", label: "Kategori", type: "text" },
          { key: "unit", label: "Satuan", type: "text", default: "pcs" },
          { key: "dimensions", label: "Dimensi / Ukuran", type: "text", hint: "Contoh: 20x10x6 cm" },
          { key: "product_type", label: "Jenis Beton", type: "select", options: [
            { value: "low_carbon", label: "Rendah Karbon" },
            { value: "conventional", label: "Konvensional" },
          ], default: "low_carbon", required: true },
          { key: "description", label: "Deskripsi", type: "textarea" },
          { key: "is_active", label: "Aktif", type: "checkbox", default: true, hint: "Produk aktif di sistem" },
        ]}
        extraToolbar={toolbar}
      />
      <ImportDialog entity="products" open={importOpen} onOpenChange={setImportOpen}
        title="Import Produk"
        description="Unggah file Excel/CSV. Kolom minimal: Kode dan Nama Produk."
        onDone={() => setRefreshKey((k) => k + 1)}
      />
    </>
  );
}
